import * as React from "react";
import { IdentityName } from "source/app/presentation/MainPanel/GameIdentities/ShowIdentity/IdentityName/IdentityName";
import { IdentityPower } from "source/app/presentation/MainPanel/GameIdentities/ShowIdentity/IdentityPower/IdentityPower";
import { IdentityScore } from "source/app/presentation/MainPanel/GameIdentities/ShowIdentity/IdentityScore/IdentityScore";
import RenderSwal from "source/app/services/Shared/RenderSwal/RenderSwal";
import { IGameIdentityDTO } from "motw_core/DTOs/IGameIdentityDTO";
import { EditMaxScore } from "source/app/presentation/MainPanel/GameIdentities/ShowIdentity/EditMaxScore/EditMaxScore";
import { IdentityGoals } from "source/app/presentation/MainPanel/GameIdentities/ShowIdentity/IdentityGoals/IdentityGoals";
import { IdentityIconPicker } from "source/app/presentation/MainPanel/GameIdentities/ShowIdentity/IdentityIconPicker/IdentityIconPicker";
import { IdentityType } from "source/app/presentation/MainPanel/GameIdentities/ShowIdentity/IdentityType/IdentityType";

export function ShowIdentityDetails(
    identity: IGameIdentityDTO,
    goalNamesLoggedToday: string[]
) {
    RenderSwal(
        null,
        <div>
            <IdentityName name={identity.name} />
            <IdentityType identity={identity} />
            <IdentityPower identity={identity} />
            <IdentityScore identity={identity} />
            <EditMaxScore
                identity={identity}
                goalNamesLoggedToday={goalNamesLoggedToday}
            />
            <IdentityIconPicker identity={identity} />
            <IdentityGoals
                identity={identity}
                goalNamesLoggedToday={goalNamesLoggedToday}
            />
        </div>,
        () => {}
    );
}
